// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 668) return "static/chunks/668-37b348295faf6069.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"5a99d42f0d8fb15e","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"67441c9068491f6e","367":"c900377a210cb98c","639":"e78fb348ab34d1a5","748":"f938c9fe8b54ae57"}[chunkId] + ".js";
};